import { render, staticRenderFns } from "./paymenttochina.vue?vue&type=template&id=410d3753&scoped=true"
import script from "./paymenttochina.vue?vue&type=script&lang=js"
export * from "./paymenttochina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d3753",
  null
  
)

export default component.exports